import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
// Establecer el título de la página inmediatamente
document.title = 'VAXTECH GROUP SAS';
render(<AppRouter data-id="element-161" />, document.getElementById('root'));